module.exports = __webpack_public_path__ + "img/plant_4_small.4b0523c2.webp";